import React, { ReactNode } from 'react';
import { Modal } from '../../ui/Modal';
import { modalBackdropStyles, modalHeaderStyles, modalStyles } from './styled';
import { BackButtonIconEnum } from '../../ui/PageHeader/types';

interface MapItemsModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  container?: Element;
  children: ReactNode;
}

export const MapItemsModal: React.FC<MapItemsModalProps> = ({
  isOpen,
  onClose,
  title,
  container,
  children
}) => {
  return (
    <Modal
      modalId="map-items-modal"
      cypress="map-items-modal"
      isOpen={isOpen}
      onClose={onClose}
      modalStyles={modalStyles}
      title={title}
      headerIcon={BackButtonIconEnum.Close}
      closeButtonAlign="left"
      modalBackdropStyles={modalBackdropStyles}
      container={container}
      headerStyles={modalHeaderStyles}
      showHeaderBorder={false}
    >
      {children}
    </Modal>
  );
};
